<template>
  <div
    class="font-normal text-gray-mobly54 space-y-4 py-2"
  >
    <div
      class="space-y-2"
    >
      <div class="block items-center md:flex justify-start md:space-x-2 space-x-0 space-y-2 md:space-y-0 text-start">
        <p
          class="font-semibold text-2xl md:text-3xl text-nowrap"
        >
          Detalhes do Pedido: {{ order.orderNr }}
        </p>
        <p
          class="px-2 rounded-md text-md font-semibold w-max"
          :class="orderLabels[orderStatus].textColor"
        >
          {{ orderLabels[orderStatus].title }}
        </p>
      </div>
      <p
        class="text-sm"
      >
        Realizado em: {{ order.date }}
      </p>
    </div>

    <div
      class="grid md:grid-cols-2 grid-cols-1 items-start justify-between gap-4"
      :class="showActions() ? 'xl:grid-cols-4' : 'lg:grid-cols-3'"
    >
      <div class="bg-gray-moblyFA py-2 px-3 rounded-md h-full">
        <div>
          <div
            class="flex justify-between w-full items-center"
            @click="toggleShowClientData = !toggleShowClientData"
          >
            <div
              class="flex items-center"
            >
              <span
                class="text-lg font-semibold"
              >
                Dados do Titular da Compra
              </span>
            </div>

            <div
              class="block md:hidden"
            >
              <svg
                v-if="!toggleShowClientData"
                xmlns="http://www.w3.org/2000/svg"
                class="w-5 h-5 text-purple-mobly"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M19 9l-7 7-7-7"
                />
              </svg>

              <svg
                v-else
                xmlns="http://www.w3.org/2000/svg"
                class="w-5 h-5 text-purple-mobly"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 15l7-7 7 7"
                />
              </svg>
            </div>
          </div>

          <div
            class="md:grid"
            :class="toggleShowClientData ? 'grid' : 'hidden'"
          >
            <span>
              {{ customer.name }}
            </span>
            <span>
              CPF/CNPJ: {{ customer.document | formatClientDocument }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="bg-gray-moblyFA py-2 px-3 rounded-md h-full"
        :class="showActions() ? '' : 'md:order-last col-span-1 md:col-span-2 lg:col-span-1'"
      >
        <div>
          <div
            class="flex items-center justify-between w-full"
            @click="toggleShowDelivery = !toggleShowDelivery"
          >
            <div
              class="flex items-center"
            >
              <span
                class="text-lg font-semibold"
              >
                Endereço de Entrega do Pedido
              </span>
            </div>

            <div
              class="block md:hidden"
            >
              <svg
                v-if="!toggleShowDelivery"
                xmlns="http://www.w3.org/2000/svg"
                class="w-5 h-5 text-purple-mobly"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M19 9l-7 7-7-7"
                />
              </svg>

              <svg
                v-else
                xmlns="http://www.w3.org/2000/svg"
                class="w-5 h-5 text-purple-mobly"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 15l7-7 7 7"
                />
              </svg>
            </div>
          </div>

          <div
            class="md:grid"
            :class="toggleShowDelivery ? 'grid' : 'hidden'"
          >
            <p>
              {{ order.shipping.shippingAddress.street + ', ' + order.shipping.shippingAddress.street_number + getComplement(order.shipping.shippingAddress) }}
            </p>
            <p>
              {{ order.shipping.shippingAddress.reference_point }}
            </p>
            <p>
              {{ order.shipping.shippingAddress.neighborhood + ' - ' + order.shipping.shippingAddress.city_name + ' - ' + order.shipping.shippingAddress.state_name }}
            </p>
            <p>
              {{ order.shipping.shippingAddress.zipcode }}
            </p>
            <span>
              Telefone: {{ getContact(order.shipping) | formatPhone }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="bg-gray-moblyFA py-2 px-3 rounded-md h-full"
        :class="showActions() ? '' : 'lg:order-last'"
      >
        <div
          class="flex items-center justify-between w-full"
          @click="toggleShowPaymentData = !toggleShowPaymentData"
        >
          <div
            class="flex items-center"
          >
            <span
              class="text-lg font-semibold"
            >
              Dados de Pagamento do Pedido
            </span>
          </div>

          <div
            class="block md:hidden"
          >
            <svg
              v-if="!toggleShowPaymentData"
              xmlns="http://www.w3.org/2000/svg"
              class="w-5 h-5 text-purple-mobly"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 9l-7 7-7-7"
              />
            </svg>

            <svg
              v-else
              xmlns="http://www.w3.org/2000/svg"
              class="w-5 h-5 text-purple-mobly"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 15l7-7 7 7"
              />
            </svg>
          </div>
        </div>

        <div>
          <div
            class="md:grid"
            :class="toggleShowPaymentData ? 'grid' : 'hidden'"
          >
            <table>
              <tr>
                <td
                  class="pr-2"
                >
                  Forma de Pagamento
                </td>

                <td class="flex justify-end text-right">
                  {{ order.paymentMethod }}
                </td>
              </tr>
              <tr>
                <td
                  class="pr-2"
                >
                  Subtotal {{ order.itemsCount > 1 ? `(${order.itemsCount } Itens)` : '(1 Item)' }}
                </td>
                <td class="flex justify-end">
                  {{ order.invoice.unit_amount | formatCurrency }}
                </td>
              </tr>
              <tr>
                <td
                  class="pr-2"
                >
                  Descontos
                </td>
                <td class="flex justify-end">
                  -{{ order.invoice.discount_amount | formatCurrency }}
                </td>
              </tr>
              <tr>
                <td
                  class="pr-2"
                >
                  Total de frete
                </td>
                <td class="flex justify-end">
                  {{ order.invoice.shipping_amount | formatCurrency }}
                </td>
              </tr>
              <tr>
                <td
                  class="pr-2"
                >
                  Total de montagem
                </td>
                <td class="flex justify-end">
                  {{ order.invoice.assembly_amount | formatCurrency }}
                </td>
              </tr>
              <tr>
                <td
                  class="pr-2"
                >
                  Vale Troca
                </td>
                <td class="flex justify-end">
                  {{ getExchange(order.invoice)| formatCurrency }}
                </td>
              </tr>
              <tr>
                <td
                  class="pr-2"
                >
                  Valor Total do pedido
                </td>
                <td class="flex justify-end font-semibold">
                  {{ getTotalOrder(order.payments)| formatCurrency }}
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div
        id="show-buttons-actions"
        class="bg-gray-moblyFA py-2 px-3 rounded-md h-full"
        v-if="showActions()"
      >
        <div>
          <span
            class="text-lg font-semibold"
          >
            Precisa de ajuda?
          </span>

          <div
            class="text-md text-purple-mobly2A8 whitespace-nowrap flex flex-col items-start space-y-1"
          >
            <button
              v-if="isBoleto(order) && showButtonBoleto()"
              @click="openBoleto(order)"
              class="hover:underline font-semibold"
            >
              Baixar boleto
            </button>

            <button
              v-if="showButtonHelpPayments()"
              id="button-help-payments"
              class="hover:underline font-semibold"
              @click="showModalHelpPayments = true"
            >
              Ajuda sobre o pagamento
            </button>

            <button
              class="hover:underline font-semibold"
              @click="showModalChangeOrder = true"
            >
              É possível alterar o pedido?
            </button>
          </div>
        </div>
      </div>
    </div>

    <Modal
      id="modal-help-payments"
      :show="showModalHelpPayments"
    >
      <div
        slot="content"
        class=""
      >
        <div
          id="header"
          class="flex items-center justify-between px-3 py-2 text-white border-0 rounded bg-purple-mobly"
        >
          <span
            class="text-lg font-semibold"
          >
            Ajuda sobre o pagamento
          </span>

          <button
            class="focus:outline-none focus:ring-0"
            @click="showModalHelpPayments = false"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div
          class="grid items-center justify-center px-3 py-10 space-y-2 text-lg justify-items-center"
        >
          <span
            class="text-center"
          >
            {{ orderLabels[orderStatus].paymentHelpMessage }}
          </span>

          <button
            class="text-white flex justify-center items-center space-x-2 font-semibold py-1.5 px-2 flex-nowrap border-1 border-purple-mobly rounded-md min-w-50 bg-purple-mobly hover:bg-purple-mobly-dark transition-colors focus:outline-none focus:ring-0 relative"
            @click="openSelfService(order.orderNr)"
          >
            Abrir atendimento
          </button>

          <button
            class="text-purple-mobly flex justify-center items-center space-x-2 font-semibold py-1.5 px-2 flex-nowrap border-1 border-purple-mobly rounded-md min-w-50 bg-white hover:border-purple-mobly-dark hover:text-purple-mobly-dark transition-colors focus:outline-none focus:ring-0 relative"
            @click="showModalHelpPayments = false"
          >
            Voltar
          </button>
        </div>
      </div>
    </Modal>

    <Modal
      id="modal-change-order"
      :show="showModalChangeOrder"
    >
      <div
        slot="content"
      >
        <div
          id="header"
          class="flex items-center justify-between w-full px-3 py-2 text-white border-0 rounded bg-purple-mobly"
        >
          <span
            class="text-lg font-semibold"
          >
            É possível alterar o pedido?
          </span>

          <button
            class="focus:outline-none focus:ring-0"
            @click="showModalChangeOrder = false"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div
          class="grid items-center justify-center px-3 py-10 space-y-2 text-lg justify-items-center"
        >
          <span
            class="text-center"
          >
            Os dados de compra não podem ser alterados. Para realizar um novo pedido, cancele os itens desejados.
          </span>

          <button
            class="text-purple-mobly flex justify-center items-center space-x-2 font-semibold py-1.5 px-2 flex-nowrap border-1 border-purple-mobly rounded-md min-w-50 bg-white hover:border-purple-mobly-dark hover:text-purple-mobly-dark transition-colors focus:outline-none focus:ring-0 relative"
            @click="showModalChangeOrder = false"
          >
            Voltar
          </button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { AsYouType } from 'libphonenumber-js'
import {
  PAYMENT_PENDING,
  PAYMENT_NOT_APPROVED,
  PAYMENT_REPROVED,
  CANCELED,
  FINISHED
} from '@/enum/enum.cluster.status'
import { formatDocument, currencyFormat } from '@/functions'
import Modal from '@/components/Commons/Modal'

export default {
  name: 'OrderHeader',

  props: {
    order: {
      type: Object,
      require: true
    }
  },

  components: {
    Modal
  },

  filters: {
    formatClientDocument: value => formatDocument(value),
    formatCurrency: value => currencyFormat(value),
    formatPhone: value => !value ? '--' : new AsYouType('BR').input(value)
  },

  data () {
    return {
      customer: {},
      toggleShowClientData: false,
      toggleShowDelivery: false,
      toggleShowPaymentData: false,
      showModalHelpPayments: false,
      showModalChangeOrder: false,
      orderStatus: 'default',
      statusShowActions: [
        'paymentPending',
        'paymentNoAprove',
        'orderInProgress'
      ],
      statusShowButtonBoleto: [
        'paymentPending',
        'paymentNoAprove'
      ],
      statusShowButtonPayment: [
        'paymentPending',
        'paymentNoAprove'
      ],
      orderLabels: {
        paymentPending: {
          title: 'Seu pedido está em análise de pagamento',
          textColor: 'bg-blue-500 text-white',
          paymentHelpMessage: 'O pagamento ainda não foi aprovado. Gostaria de abrir um atendimento?'
        },
        paymentNoAprove: {
          title: 'Seu pagamento não foi aprovado :(',
          textColor: 'bg-red-500 text-white',
          paymentHelpMessage: 'Infelizmente, o pagamento não foi aprovado. Gostaria de abrir um atendimento?'
        },
        orderInProgress: {
          title: 'Seu pedido está em andamento',
          textColor: 'bg-green-500 text-white'
        },
        orderFinish: {
          title: 'Suas Compras',
          textColor: 'bg-gray-600 text-white'
        },
        orderCanceled: {
          title: 'Seu pedido foi cancelado',
          textColor: 'bg-red-500 text-white'
        },
        default: {
          title: '--',
          textColor: 'bg-gray-600 text-white'
        }
      }
    }
  },

  mounted () {
    this.orderStatus = this.getOrderStatus(this.order.products)
    this.customer = this.getCustomer(this.order)
  },

  methods: {
    getCustomer (order) {
      if (!order || !order.products[0]) return {}

      const customer = order.products[0].customer

      return customer
    },

    isBoleto (order) {
      return order != null && order.boleto != null
    },

    showActions () {
      const isCurrentStatusValid = this.statusShowActions.includes(this.orderStatus)

      return isCurrentStatusValid
    },

    showButtonBoleto () {
      const isCurrentStatusValid = this.statusShowButtonBoleto.includes(this.orderStatus)

      return isCurrentStatusValid
    },

    showButtonHelpPayments () {
      const isCurrentStatusValid = this.statusShowButtonPayment.includes(this.orderStatus)

      return isCurrentStatusValid
    },

    getTotalOrder (payments) {
      return payments.reduce((acc, payment) => acc + payment.amount, 0)
    },

    getExchange (invoice) {
      const exchangeInProduct = invoice.discounts.find(discount =>
        discount && discount.type && discount.type.cod === 'EXCHANGE_COUPON_APPLIED_IN_PRODUCT'
      )

      if (!exchangeInProduct) return 0

      const exchangeInShipping = invoice.discounts.find(discount =>
        discount && discount.type && discount.type.cod === 'EXCHANGE_COUPON_APPLIED_IN_SHIPPING'
      )

      return exchangeInProduct.applied_amount + exchangeInShipping.applied_amount
    },

    getContact (shipping) {
      if (!shipping.contact_details) return

      const contact = shipping.contact_details.phones.find(phone => phone.type.cod === 'PRIMARY')

      return contact ? contact.phone_number : null
    },

    openBoleto (order) {
      if (!order.boleto) return false

      window.open(order.boleto, '_blank')
    },

    openSelfService (orderNumber) {
      const url = 'https://api.mobly.com.br/cs-external/redirect-self-service?order=' + orderNumber

      window.open(url, '_blank')
    },

    getOrderStatus (items) {
      const itemsStatus = this.getItemsStatusClusters(items)

      if (itemsStatus.find(status => status.cluster === PAYMENT_PENDING && status.code !== 'CONFIRMED')) return 'paymentPending'

      if (itemsStatus.find(status => status.cluster === PAYMENT_NOT_APPROVED)) return 'paymentNoAprove'

      if (itemsStatus.find(status => status.cluster === PAYMENT_REPROVED)) return 'paymentNoAprove'

      if (itemsStatus.every(status => status.cluster === CANCELED)) return 'orderCanceled'

      if (itemsStatus.every(status => status.cluster === FINISHED)) return 'orderFinish'

      return 'orderInProgress'
    },

    getItemsStatusClusters (items) {
      return items.map(item => ({ cluster: item.lastStatus.cluster.toUpperCase(), code: item.lastStatus.code.cod }))
    },

    getComplement (address) {
      return address.complement ? ', ' + address.complement : ''
    }
  }
}
</script>
